import { IRootCause } from '@/interfaces/IAssessmentData';
import styles from './AssessmentReport.module.css';
import { useRef } from 'react';
import { Scroller } from '../scroller/Scroller';
import { useGlobalContext } from '@/libs/context/GlobalContext';
type props = {
    data: IRootCause[]
}
export function AssessmentRootCause({ data }: props) {
    const rootCauseWrap = useRef(null);
    const { props: { isMobileView } } = useGlobalContext();
    if (data && data.length === 0) return <></>;
    return <section className={`${styles.root_warpper} pt30 pb30`} style={{ backgroundColor: "#effbf6" }}>
        <div className="container">
            <h2 className="sectionHeading">Root Causes</h2>
            <div>
                <div className={styles.over_hiden} ref={rootCauseWrap}>
                    <div className={styles.box_root}>
                        {data && data.map((f, idx) =>
                            <div className={`${styles.horigenatal_box} horigenatalBox`} key={idx}>
                                <div className={styles.heading_root_box}>
                                    <h4>{f.cause_name}</h4>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Scroller scrollContainerRef={rootCauseWrap} noOfTile={data} tileClass={'horigenatalBox'} tilesToView={isMobileView ? 1 : 4} arrowsNotReq={true} extraWidth={isMobileView ? 20 : 40} />
            </div>
        </div>
    </section>
}